import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

// TODO(intools-access): replace placeholder ids with real backend-provisioned 32-hex (T002).
export const IntoolsAccessViewCreateEditPagePageRBAC = {
  pageID: '1560b230cfe1a6d01dbd0c066205913c',
  elementID: {
    ViewCreateEditPagePage: '88b2f07d574d600c9a1e7d02236a88ce',
    SaveEditButton: 'c5aea4c408fa7c13bfcda2a5686f6500',
    SaveCreateButton: 'bfff04ac03bbcffadcd24f214057562c',
  },
} as const

export const useRBACIntoolsAccessViewCreateEditPage = createUseRBAC(
  IntoolsAccessViewCreateEditPagePageRBAC.elementID,
)

export type UseRBACIntoolsAccessViewCreateEditPageType = ReturnType<
  typeof useRBACIntoolsAccessViewCreateEditPage
>
